const Theme = {
  logo_image_url: 'defievasion.png',

  token_url: 'lecollectionneur.jpg',
  token_border: '1px solid #dddddd',
  token_border_radius: 100,
  number_hidden: true,

  button_color: '#ffd400',
  button_text_color: '#040504',
  button_radius: 2,
  button_text_weight: 400,
  button_half_border_color: '#ffd400',

  text_font: `'Open Sans', sans-serif`,
  title_font: `'Open Sans', sans-serif`,
}

export default Theme
